import * as React from "react"

import usePageHeaderLinks from "Catalog/shared/hooks/usePageHeaderLinks"
import Layout from "shared/components/Layout"
import { DisplayMode } from "shared/utils/paths"

import CatalogSelector from "../CatalogSelector"

import None from "./None"
import Sidebar from "./Sidebar"
import { Main, Page, Side } from "./Styles"
import type { SidebarItem } from "./types"

export type { SidebarItem }

interface LayoutWithSidebarProps {
  toolbar?: JSX.Element
  sidebarItems: Array<SidebarItem>
  main: JSX.Element | null
  none: string
  displayMode: DisplayMode
  testId?: string
  topPadding?: boolean
}

const LayoutWithSidebar = React.forwardRef(
  (
    { toolbar, sidebarItems, main, none, displayMode, testId, topPadding = true }: LayoutWithSidebarProps,
    $contentRef: React.ForwardedRef<HTMLDivElement>,
  ): JSX.Element => {
    const links = usePageHeaderLinks(displayMode)

    return (
      <Layout
        catalogSelector={<CatalogSelector displayMode={displayMode} />}
        links={links}
        toolbar={toolbar}
        ref={$contentRef}
      >
        <Page data-testid={testId}>
          <Side>
            <Sidebar items={sidebarItems} />
          </Side>

          <Main topPadding={topPadding || !main}>{main || <None text={none} />}</Main>
        </Page>
      </Layout>
    )
  },
)

LayoutWithSidebar.displayName = "LayoutWithSidebar"

export default LayoutWithSidebar
